import styled from 'styled-components';
import {GREY_2} from "../../utils/colors";

export const Container = styled.div`
  background: ${GREY_2};
`;
